<template>
  <div>
    <div class="send-message-box">
      <send-message-x @onViewRecord="handleViewRecord" :uploadAgainDB="uploadAgainDB" :sendType=5></send-message-x>
    </div>
  </div>
</template>
<script>
import sendMessageX from "@/components/send-message-x.vue";
export default {
  name: 'sendingVariables',
  props: {
    uploadAgainDB: {
      type: Object,
      default: () => {}
      // 指定号码发送上传手机号码, 变量短信发送
      // totalMobile fid content
    },
  },
  data() {
    return {

    }
  },
  components: {
    sendMessageX
  },
  methods: {
    handleViewRecord() {
      this.$emit('onViewRecord')
    },
  }
}
</script>

<style lang="scss" scoped>
  
</style>